export default __webpack_public_path__ + "static/media/arrow_bottom_buyer.d7bc8dc0.svg";